function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/require-default-props */
import React, { PureComponent, Children, Fragment } from 'react';
import PropTypes from 'prop-types';
import Popover from '../Popover';
import OptionsList from '../OptionsList';
import { Container } from './elements';
import DefaultHeader from './Header';
/**
 * A fake component to pass options as JSX instead of props.
 */

var Option = function Option() {
  return null;
};
/**
 * Tansform the Option component above into array of object to pass as options props to OptionsList.
 *
 * @param {*} options
 * @param {*} values
 */


var transformChildrenToOptions = function transformChildrenToOptions(children) {
  return Children.toArray(children).map(function (_ref) {
    var props = _ref.props,
        type = _ref.type;
    return type === Option ? {
      label: props.label || props.children,
      value: props.value || props.children.toString()
    } : null;
  }).filter(Boolean);
};
/**
 * Default function to use to display selected values.
 *
 * @param {array} selected - the selected options
 * @param {array} values - the selected values
 * @param {array} options - the options available
 */
// eslint-disable-next-line no-unused-vars


var defaultDisplayValue = function defaultDisplayValue(selected, _values, _options) {
  return selected.map(function (_ref2, index) {
    var value = _ref2.value,
        label = _ref2.label;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: value
    }, index > 0 && ', ', label);
  });
};
/**
 * A Dropdown displays content through its children prop that must be components wrapping text.
 * The trigger is a button displaying text provided by the prop `title`
 *
 * See README.md and storybook for more documentation
 *
 * @return {jsx}
 */


var Select = /*#__PURE__*/function (_PureComponent) {
  _inherits(Select, _PureComponent);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      values: [],
      searchKeyword: '',
      portalPosition: {
        left: '0px',
        top: '0px'
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function (prop) {
      var props = _this.props;
      return props.hasOwnProperty(prop);
    });

    _defineProperty(_assertThisInitialized(_this), "getControllableValue", function (key) {
      var props = _this.props;
      var state = _this.state;
      return _this.isControlled(key) ? props[key] : state[key];
    });

    _defineProperty(_assertThisInitialized(_this), "onClickOutside", function (event) {
      var onToggle = _this.props.onToggle;

      if (_this.isControlled('isOpen')) {
        onToggle && onToggle(event);
      } else {
        _this.setState({
          isOpen: false
        }, function () {
          onToggle && onToggle(false);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (values) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          allowMultiple = _this$props.allowMultiple;

      if (_this.isControlled('values')) {
        if (onChange) {
          onChange(values);
        }
      } else {
        _this.setState({
          values: values
        });
      }

      if (!_this.isControlled('isOpen') && !allowMultiple) {
        _this.setState({
          isOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      var isOpen = _this.getControllableValue('isOpen');

      var _this$props2 = _this.props,
          onToggle = _this$props2.onToggle,
          disabled = _this$props2.disabled;
      if (disabled) return;

      if (_this.isControlled('isOpen')) {
        onToggle && onToggle(event);
      } else {
        _this.setState(function (prevState) {
          return {
            isOpen: !prevState.isOpen
          };
        }, function () {
          onToggle && onToggle(!isOpen);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "triggerRef", function (ref) {
      var contentWidth = ref && ref.offsetWidth;

      _this.setState({
        contentWidth: "".concat(contentWidth, "px")
      });
    });

    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          children = _this$props3.children,
          className = _this$props3.className,
          HeaderComponent = _this$props3.HeaderComponent,
          placeholder = _this$props3.placeholder,
          onChange = _this$props3.onChange,
          disabled = _this$props3.disabled,
          displayValue = _this$props3.displayValue,
          animationVariants = _this$props3.animationVariants,
          contentRef = _this$props3.contentRef,
          contentWrapperStyle = _this$props3.contentWrapperStyle,
          modifiers = _this$props3.modifiers,
          placement = _this$props3.placement,
          portalPosition = _this$props3.portalPosition,
          positionFixed = _this$props3.positionFixed,
          triggerWrapperCss = _this$props3.triggerWrapperCss,
          usePortal = _this$props3.usePortal,
          optionsListProps = _objectWithoutProperties(_this$props3, ["options", "children", "className", "HeaderComponent", "placeholder", "onChange", "disabled", "displayValue", "animationVariants", "contentRef", "contentWrapperStyle", "modifiers", "placement", "portalPosition", "positionFixed", "triggerWrapperCss", "usePortal"]);

      var contentWidth = this.state.contentWidth;
      var isOpen = this.getControllableValue('isOpen');
      var values = this.getControllableValue('values') || [];
      var Header = HeaderComponent || DefaultHeader;
      var selectOptions = options || transformChildrenToOptions(children);
      var selected = values.map(function (value) {
        return selectOptions.find(function (option) {
          return option.value === value;
        });
      }).filter(Boolean);
      var value = displayValue || defaultDisplayValue;
      return /*#__PURE__*/React.createElement(Container, {
        className: className,
        disabled: disabled,
        "data-testid": "select"
      }, /*#__PURE__*/React.createElement(Popover, {
        content: /*#__PURE__*/React.createElement(OptionsList, _extends({
          options: selectOptions,
          values: values,
          OptionComponent: OptionsList.SimpleOption,
          onChange: this.onChange
        }, optionsListProps)),
        contentWrapperStyle: _objectSpread({
          display: 'flex',
          overflow: 'hidden',
          originX: '50%',
          originY: '0%',
          zIndex: 1000
        }, contentWrapperStyle),
        isOpen: isOpen,
        onClickOutside: this.onClickOutside,
        triggerRef: this.triggerRef,
        width: contentWidth,
        contentRef: contentRef,
        animationVariants: animationVariants,
        modifiers: modifiers,
        placement: placement,
        portalPosition: portalPosition,
        positionFixed: positionFixed,
        triggerWrapperCss: triggerWrapperCss,
        usePortal: usePortal
      }, /*#__PURE__*/React.createElement(Header, {
        options: selectOptions,
        values: values,
        onClick: this.toggleMenu,
        isOpen: isOpen,
        placeholder: placeholder,
        disabled: disabled
      }, value && typeof value === 'function' ? value(selected, values, selectOptions) : value)));
    }
  }]);

  return Select;
}(PureComponent);
/**
 * PropTypes Validation
 */


var array = PropTypes.array,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    object = PropTypes.object,
    oneOfType = PropTypes.oneOfType,
    string = PropTypes.string;
Select.propTypes = {
  /**
   * OptionsList props to allow multiple select values
   */
  allowMultiple: bool,

  /**
   * Must be multiple children each containing a value prop
   */
  children: node,

  /**
   * Prop needed by styled components
   */
  className: string,

  /**
   * If the select should be disabled or not
   */
  disabled: bool,

  /**
   * A value or function to display the selected values.
   * It receives selected, values and options as arguments.
   * Falsy returned value will display the placeholder.
   */
  displayValue: oneOfType([node, func]),

  /**
   * Overrides header component for custom render
   */
  HeaderComponent: func,

  /**
   * Controlled value for displaying popover
   */
  isOpen: bool,

  /**
   * List of options of select.
   */
  options: array,

  /**
   * Callback fired when an element of the <Select /> is selected
   */
  onChange: func,

  /**
   * Callback fired when the <Select /> is toggled (becomes closed or open)
   */
  onToggle: func,

  /**
   * Placeholder of the <Select /> component in the header. Displayed only if no value has been set yet.
   */
  placeholder: string,

  /**
   * Selected values identifier
   */
  values: array,

  /**
   * POPOVER PROPS
   */
  animationVariants: object,
  contentRef: func,
  contentWrapperStyle: object,
  modifiers: object,
  placement: string,
  portalPosition: object,
  positionFixed: bool,
  triggerWrapperCss: array,
  usePortal: bool
};
/**
 * Default props
 */

Select.defaultProps = {
  allowMultiple: false,
  children: null,
  className: '',
  disabled: false,
  usePortal: false
};
Select.Option = Option;
Select.Header = DefaultHeader;
export default Select;